import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth.service';
import { ConfirmService } from '@luzula/luzula-lib';
import { DataService } from 'src/app/data.service';
import { Command, NavbarService } from 'src/app/navbar.service';
import { ValidationService } from '../../validation.service';
import { dateString } from 'src/app/data-model';
import { ProjectService } from 'src/app/project.service';

@Component({
    standalone: false,
    selector: 'bp-hl-area-container',
    templateUrl: 'hl-area-container.component.html',
    styleUrls: ['hl-area.component.css'],
    
})
export class HlAreaContainerComponent implements OnInit, OnDestroy{
  @Input() name!: string;
  @Input() scrollX = false;
  bp: any;
  dateString = dateString;
  private dirtySubscription?: Subscription;
  private routeSubscription?: Subscription;
  private authChangedSubscription?: Subscription;

  constructor(
    private ns: NavbarService,
    private router: Router,
    private route: ActivatedRoute,
    private vs: ValidationService,
    private ds: DataService,
    public aus: AuthService,
    private confirmService: ConfirmService,
    public ps: ProjectService
  ) { }

	ngOnInit(): void {
		this.routeSubscription = this.route.parent?.data.subscribe(data => {
			this.bp = data['bp'];
		});

		this.ns.subscribe(Command.goBackToPoint, async () => {
			if (!this.vs.dirty.value) {
				this.navigateBack();
				return;
			}
			const result = await this.confirmService.confirm({
				title: 'Ungespeicherte Änderungen',
				message: 'Es gibt ungespeicherte Änderungen an diesem Punkt.',
				confirmText: 'Verwerfen',
				confirmClass: 'btn-warning',
				extraText: 'Speichern & zurück',
				extraClass: 'btn-success',
				cancelText: 'Bleiben'
			});
			if (result === 'extra') {
				// Speichern und dann zurück
				await this.ds.saveDocument(this.bp, { user: this.aus.currentUser });
				this.vs.dirty.next(false);
				this.navigateBack();
			} else if (result === true) {
				// Verwerfen: Punkt aus DB neu laden
				this.ds.getDocument$(this.bp._id).subscribe((freshBp: any) => {
					Object.assign(this.bp, this.ds.updateBohrpunkt(freshBp));
					this.vs.dirty.next(false);
					this.navigateBack();
				});
			}
		});

		this.dirtySubscription = this.vs.dirty.subscribe(() => this.initSaveButton());
		this.authChangedSubscription = this.aus.authChanged.subscribe(() => this.initSaveButton());
		this.initSaveButton();
	}

	private navigateBack() {
		const currentRoute = this.router.url;
		const newRoute = currentRoute.substring(0, currentRoute.lastIndexOf('/'));
		this.router.navigate([newRoute]);
	}

	private initSaveButton() {
		if (this.aus.canI('write', 'points') && this.vs.dirty.value) {
			this.ns.subscribe(Command.savePoint, () => this.onSave());
		} else {
			this.ns.unsubscribe(Command.savePoint);
		}
	}

	private onSave() {
		if (!this.vs.dirty.value) return;
		this.ds.saveDocument(this.bp, { user: this.aus.currentUser });
		this.vs.dirty.next(false);
	}

	ngOnDestroy(): void {
		this.ns.unsubscribe(Command.goBackToPoint);
		this.ns.unsubscribe(Command.savePoint);
		this.dirtySubscription?.unsubscribe();
		this.routeSubscription?.unsubscribe();
		this.authChangedSubscription?.unsubscribe();
	}
}
